import React, { useState, useContext, useEffect, useRef } from 'react';
import './App.css';
import 'primeflex/primeflex.css';
import 'primeicons/primeicons.css';
import 'primereact/resources/primereact.min.css';
import 'primereact/resources/themes/lara-light-cyan/theme.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthContext } from "./modules/context/AuthContext";  // Solo importamos el contexto, no el provider
import { Toast } from 'primereact/toast';
import FullScreenSpinner from './modules/components/FullScreenSpinner';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { Divider } from 'primereact/divider';


// COMPONENTES
import Header from './modules/components/Header';
import MySidebar from './modules/components/Sidebar';
import Home from './modules/components/Home';
import Inventario from './modules/components/Inventario';
import ListadoPrecios from './modules/components/ListadoPrecios';
import Login from './modules/components/Login';
import ListadoPreciosDetalle from './modules/components/ListadoPreciosDetalle';
import ListadoPreciosGenerados from './modules/components/ListadoPreciosGenerados';
import Presupuesto from './modules/components/Presupuesto';
import PanelCompras from './modules/components/PanelCompras';
import Configuraciones from './modules/components/Configuraciones';
import RegistroContable from './modules/components/RegistroContable';
import PresupuestosListado from './modules/components/PresupuestosListado';
import PresupuestoDetalle from './modules/components/PresupuestoDetalle';

function App() {
  const [sidebarVisible, setSidebarVisible] = useState(false);
  const { user } = useContext(AuthContext); // Ya podemos usar el contexto porque estamos dentro del Provider
  const toast = useRef(null);

  const [loading, setLoading] = useState(false); // Estado del spinner
  const [confirmDialog, setConfirmDialog] = useState(false);


  const handleProcess = () => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setConfirmDialog(true); // Mostrar el diálogo de confirmación
    }, 3000); 
  };

  return (
      <Router>
        <Toast ref={toast} position="bottom-right" />
        <FullScreenSpinner visible={loading} />

        {user ? (
          <div className='background-style'>
            <Header onSidebarToggle={() => setSidebarVisible(true)} toast={toast} /> 
            <MySidebar visible={sidebarVisible} onHide={() => setSidebarVisible(false)} /> 
            <div className={`content ${sidebarVisible ? 'content-shifted' : ''}`} style={{ backgroundColor: "#fff", marginRight:"1vw", marginTop:"6vw" }}>
              <Routes>
                <Route path="/" element={<Home  onProcess={handleProcess}/>} />
                <Route path="/presupuesto" element={<Presupuesto toast={toast} setLoading={setLoading} setConfirmDialog={setConfirmDialog} />} />
                <Route path="/presupuesto/:id" element={<PresupuestoDetalle toast={toast} />} />
                <Route path="/listado_presupuestos" element={<PresupuestosListado toast={toast} />} />
                <Route path="/inventario" element={<Inventario toast={toast} />} />
                <Route path="/listado_precios" element={<ListadoPrecios toast={toast} setLoading={setLoading} setConfirmDialog={setConfirmDialog} />} />
                <Route path="/listado_precios_detalle/:id" element={<ListadoPreciosDetalle />} />
                <Route path="/listado_precios_generados" element={<ListadoPreciosGenerados />} />
                <Route path="/panel_compras" element={<PanelCompras toast={toast} />} />
                <Route path="/registro_contable" element={<RegistroContable toast={toast} />} />
                <Route path="/configuraciones" element={<Configuraciones toast={toast} />} />
              </Routes>
            </div>
          </div>
        ) : (
          <Login />
        )}

              {/* Diálogo de confirmación */}
              <Dialog 
              visible={confirmDialog} 
              onHide={() => setConfirmDialog(false)} 
              header={null} // Ocultamos el header por diseño
              className="custom-dialog"
            >
              <div className="dialog-content">
                <i className="pi pi-check-circle" style={{ fontSize: "3rem", color: "#28a745" }}></i>
                <h2>Presupuesto creado!</h2>
                <Divider />
                <p>El presupuesto ha sido creado exitosamente!</p>
                <Button 
                  label="Aceptar" 
                  icon="pi pi-check" 
                  className="p-button-success p-button-rounded p-button-lg animate-button" 
                  onClick={() => setConfirmDialog(false)} 
                />
              </div>
            </Dialog>
      </Router>
  );
}

export default App;
